module.exports = __webpack_public_path__ + "static/media/7.16f3d991.jpg";